import React, { Component } from "react"
import config from "react-global-configuration"
import ReceiptBookingInfo from "./ReceiptBookingInfo"
import * as tracking from "../../helpers/tracking"
import { setQueryStringValue } from "../../../api/queryStringHelper"
import * as cookieNames from "../../constants/Cookies"
import QueryString from "query-string"
import Accordion from "../../../styleguide/js/components/accordion"
import axios from "axios"
import * as cookieHelper from "../../../helpers/cookie"
import * as storageHelper from "../../../helpers/storageHelper"
import * as endpoints from "../../../api/endpoints"

class Receipt extends Component {
  constructor(props) {
    super(props)
    this.accordionContainerRef = React.createRef()

    this.state = {
      isActive: false,
      isPageViewTracked: false,
      isOrderCompleteTracked: false,
      detailsExpanded: false,
      flightLink: "",
    }
  }
  async componentDidMount() {
    if (this.props.bookingResult) window.products = tracking.getProducts(this.props)
    var sleeknoteScriptTag = document.createElement("script")
    sleeknoteScriptTag.type = "text/javascript"
    sleeknoteScriptTag.charset = "utf-8"
    sleeknoteScriptTag.src = "//sleeknotecustomerscripts.sleeknote.com/5526.js"
    var s = document.getElementById("sleeknoteScript")
    s.parentNode.insertBefore(sleeknoteScriptTag, s)

    // Track epi A/B
    let bookingReceiptTextKeys = config.get("textKeys.receipt.booking") || {}
    if (bookingReceiptTextKeys.trackingUrl) {
      axios.head(bookingReceiptTextKeys.trackingUrl).catch((e) => console.log(e))
    }

    const queryParam = QueryString.parse(this.props.location.search)
    if (!queryParam.pvt && !this.state.isPageViewTracked && !this.props.cookies.get(cookieNames.ACCESS_TOKEN)) {
      // only track new design on receipt when its a standard booking, i.e. when the podium has been seen - it wont be seen in amendments or extensions
      tracking.trackPageView(
        this.props,
        "parking receipt page",
        "/virtual/(|en/|sv/)parkering/receipt" + `${this.props.useNewDesign && queryParam.source === "standard" ? "?newDesign=true" : ""}`,
      )
      this.setState({ isPageViewTracked: true }, () => setQueryStringValue("pvt", true))
    }
    if (!queryParam.oct && !this.state.isOrderCompleteTracked && this.props.bookingResult) {
      const queryParam = QueryString.parse(this.props.location.search)
      let props = { ...this.props }
      props.useNewDesign = this.props.useNewDesign && queryParam.source === "standard" // only track new design on receipt when its a standard booking, i.e. when the podium has been seen - it wont be seen in amendments or extensions
      if (queryParam.walletname?.toLowerCase() === "mobilepay") {
        if (props && !props.selectedPaymentType) {
          props.selectedPaymentType = { cardType: "mobilepay" }
        } else {
          props.selectedPaymentType.cardType = "mobilepay"
        }
      }
      props = this.trackUpsale(props)
      tracking.trackOrderComplete(props)
      this.setState({ isOrderCompleteTracked: true }, () => setQueryStringValue("oct", true))
    }
    storageHelper.removeFromSessionStorage("emailUpgradeGuid")
    this.props.setDataToState({ emailUpgradeGuid: null })

    if (this.props.flightId) {
      const response = await endpoints.getFlightLink({ flightId: this.props.flightId, language: this.props.locale })
      if (response && response.data) {
        this.setState({ flightLink: response.data })
      }
    }
  }

  componentDidUpdate() {
    if (this.props.bookingResult) window.products = tracking.getProducts(this.props)
    const queryParam = QueryString.parse(this.props.location.search)
    if (!queryParam.pvt && !this.state.isPageViewTracked && this.props.userAccountDetails) {
      // only track new design on receipt when its a standard booking, i.e. when the podium has been seen - it wont be seen in amendments or extensions
      tracking.trackPageView(
        this.props,
        "parking receipt page",
        "/virtual/(|en/|sv/)parkering/receipt" + `${this.props.useNewDesign && queryParam.source === "standard" ? "?newDesign=true" : ""}`,
      )
      this.setState({ isPageViewTracked: true }, () => setQueryStringValue("pvt", true))
    }
    if (!queryParam.oct && !this.state.isOrderCompleteTracked && this.props.bookingResult) {
      let props = { ...this.props }
      props.useNewDesign = this.props.useNewDesign && queryParam.source === "standard" // only track new design on receipt when its a standard booking, i.e. when the podium has been seen - it wont be seen in amendments or extensions
      if (queryParam.walletname?.toLowerCase() === "mobilepay") {
        if (props && !props.selectedPaymentType) {
          props.selectedPaymentType = { cardType: "mobilepay" }
        } else {
          props.selectedPaymentType.cardType = "mobilepay"
        }
      }
      props = this.trackUpsale(props)
      tracking.trackOrderComplete(props)
      this.setState({ isOrderCompleteTracked: true }, () => setQueryStringValue("oct", true))
    }
    if (this.accordionContainerRef.current) {
      new Accordion({
        el: this.accordionContainerRef.current,
        eventName: Accordion.EVENT.CLICK,
        disposable: false,
        persistentElement: null,
      })
      // bind only once hack, included library is not doing double binding checks, sic!
      this.accordionContainerRef.current = null
    }
  }
  handleExpandCollapse = () => {
    var eventLabel = this.state.detailsExpanded ? "collaps" : "expand"
    tracking.trackParkingFlowClick("order details", eventLabel, this.props)
    this.setState({ detailsExpanded: !this.state.detailsExpanded })
  }

  trackUpsale = (props) => {
    let returnProps = props
    const upsaleTrackingData = cookieHelper.getCookie("upsaleTrackingData")
    if (upsaleTrackingData) {
      returnProps.upsaleTrackingData = upsaleTrackingData
      cookieHelper.deleteCookie("upsaleTrackingData")
      tracking.trackParkingProductUpgrade(returnProps.bookingResult, upsaleTrackingData, "purchase")
    }
    return returnProps
  }
  render() {
    const textKeys = config.get("textKeys.receipt.confirm") || {}
    const allKeys = config.get("textKeys.receipt") || {}
    const customerReceiptTextKeys = config.get("textKeys.receipt.customer") || {}

    const queryParam = QueryString.parse(this.props.location.search)

    let isExtendedBooking = false
    let isAmendment = false
    if (queryParam.source === "extension") {
      isExtendedBooking = true
    }
    if (queryParam.source === "amend") {
      isAmendment = true
    }

    if (!this.props.bookingResult) return ""

    const { booking, activeBookingExtraProducts } = this.props.bookingResult

    const vehicleInfo = []
    booking.vehicleMake && vehicleInfo.push(booking.vehicleMake)
    booking.vehicleModel && vehicleInfo.push(booking.vehicleModel)
    booking.vehicleColour && vehicleInfo.push(booking.vehicleColour)
    const vehicleInfoText = vehicleInfo.join(", ")

    return (
      <React.Fragment>
        <section className="deck deck--white deck--padding-top">
          <div className="w--wider">
            <header className="section-header section-header--significant">
              <div className="section-header__inner">
                {this.props.flightId ? (
                  <nav className="section-header__inner__nav">
                    <a
                      href={this.state.flightLink}
                      className="button button--link button--link--back has-icon rm-this-class rm-this-class-hide-default"
                    >
                      <span className="text">Tilbage til flyafgang</span>
                    </a>
                  </nav>
                ) : (
                  ""
                )}
                {isAmendment ? (
                  <h2>{allKeys.booking.amendHeader || "Du har ændret din reservation!"}</h2>
                ) : isExtendedBooking ? (
                  <h2>{allKeys.booking.extendHeader || "Du har ændret dit udkørselstidspunkt!"}</h2>
                ) : (
                  <h2>{textKeys.header || "Tak for din reservation"}</h2>
                )}
              </div>
            </header>
          </div>
        </section>

        <section className="deck deck--white deck--extra-padding-bottom">
          <div className="w--wider">
            <div className="parking-receipt">
              <ReceiptBookingInfo
                activeBookingExtraProducts={activeBookingExtraProducts}
                arrivalDate={this.props.bookingResult.booking.arrivalDate}
                arrivalTime={this.props.bookingResult.booking.arrivalTime}
                departureDate={this.props.bookingResult.booking.departureDate}
                departureTime={this.props.bookingResult.booking.departureTime}
                isAmendment={isAmendment}
                isExtendedBooking={isExtendedBooking}
                cookies={this.props.cookies}
                {...this.props}
              />
              <div className={`js--accordion `} ref={this.accordionContainerRef}>
                <div className="js--accordion-content">
                  <div className="parking-receipt__bottom">
                    <h5>{customerReceiptTextKeys.header}</h5>
                    <p>
                      {booking.firstName} {booking.lastName}
                      <br />
                      {booking.postcode ? booking.postcode : ""} {booking.town ? booking.town : ""}
                      {(booking.postcode || booking.town) && booking.country ? `, ${booking.country}` : booking.country ? booking.country : ""}
                      {booking.postcode || booking.town || booking.country ? <br /> : ""}
                      {/* {booking.postcode} {booking.town}, {booking.country}<br /> */}
                      {booking.mobilePhone}
                      <br />
                      {booking.vehicleRegistrationNumber ? (
                        <React.Fragment>
                          {vehicleInfo.length > 0 ? (
                            <React.Fragment>
                              {vehicleInfoText} <br />{" "}
                            </React.Fragment>
                          ) : null}
                          {booking.vehicleRegistrationNumber}
                        </React.Fragment>
                      ) : null}
                    </p>
                  </div>
                </div>

                <a className={`button button--expander js--accordion-trigger `} href="#" onClick={() => this.handleExpandCollapse()}>
                  {/* need textkeys here */}
                  <span className="text">{textKeys.showOrderDetails || "Vis ordredetaljer"}</span>
                  <span className="text2">{textKeys.hideOrderDetails || "Skjul ordredetaljer"}</span>
                  <span className="icon">
                    <svg className="svg-icon svg-icon--arrowdownangle">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdownangle">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }
}

export default Receipt
